import styled from 'styled-components';

const Wrapper = styled.div`
    .apply-confirmation {
        display: flex;
        align-items: center;
        .apply-restart-icon {
            width: 3rem;
        }
    }
    .apply-confirm-info {
        margin: 0.5rem;
    }
    .btn-wrapper {
        display: flex;
        align-items: center;
        margin-top: 1rem;
        .separator {
            margin-left: 1rem;
        }
        .apply-btn {
            width: 100%;
        }
    }
`;

export default Wrapper;
